let app = (function () {

    let $headerElement = $("#page-header");
    let $mainElement = $("#main-content");
    let $footerElement = $("#main-footer");

    function init() {
        setContentPaddingTop();
        setContentPaddingBottom();
        setContentMinHeight();
        setDatepickerObject();
        _bindEvents();
    }

    function _bindEvents() {
        _bindSubmitEvent();
    }

    function _bindSubmitEvent() {
        let $forms = $('form');
        let $fakeSubmitButtons = $('.btn[data-action="submit"]');

        $forms.on('submit', function () {
            let $submitButton = $('button[type="submit"]', $(this));
            _setButtonStateSubmitted($submitButton);
        });

        $fakeSubmitButtons.on('click', function () {
            _setButtonStateSubmitted($(this));
        });
    }

    // Add a loading animation in the button.
    function _setButtonStateSubmitted($button) {
        $button.addClass("btn-processing");
    }

    // Remove the loading animation (spinner) from the button.
    function setButtonStateNormal($button) {
        $button.removeClass("btn-processing");
    }

    function setContentPaddingTop() {
        let headerHeight = $headerElement.outerHeight(true);
        $mainElement.css('padding-top', headerHeight + "px");
    }

    function setContentPaddingBottom() {
        // Apply padding bottom only on breakpoint LARGE and up (when footer is sticky).
        if ($(window).outerWidth() > 991) {
            let footerHeight = $footerElement.outerHeight(true);
            $mainElement.css('padding-bottom', (footerHeight + 20) + "px");
        }
    }

    function setContentMinHeight() {
        let windowHeight = $(window).outerHeight(true);
        let contentMargin = $mainElement.css('margin-top').slice(0, -2);
        let footerheight = $("#main-footer").outerHeight();
        if (contentMargin.length == 0) contentMargin = 0;

        $mainElement.css('min-height', windowHeight - contentMargin - footerheight + "px");
    }

    function setDatepickerObject() {
        let date_input = $('input.datepicker');
        let trigger = $('.datepicker');
        let container = $('.bootstrap-iso form').length > 0 ? $('.bootstrap-iso form').parent() : "body";
        let options = {
            format: 'mm/yyyy',
            container: container,
            todayHighlight: true,
            autoclose: true,
            viewMode: "months",
            minViewMode: "months",
            language: "fr"
        };
        date_input.datepicker(options);
    }

    function animateTo(hash, offset) {
        let $hash = $(hash);

        if (typeof $hash == "object" && $hash.length > 0) {

            if (!offset) {
                let offset = 0;
            }

            $('html, body').animate({
                    scrollTop: $(hash).offset().top - offset
                }, 500
            );
        } else {
            console.log("$hash must be a jquery object.");
        }
    }

    return {
        init: init,
        setContentPaddingTop: setContentPaddingTop,
        setContentPaddingBottom: setContentPaddingBottom,
        headerElement: $headerElement,
        animateTo: animateTo,
        setButtonStateNormal: setButtonStateNormal
    }
})();


// Window and document events.
$('document').ready(function () {

    app.init();

    $(window).resize(function () {

        app.setContentPaddingTop();
        app.setContentPaddingBottom();
    });
});
